import { useLocation } from '@react-router';
import type { CatalogEmbedConfig } from './CatalogEmbed.types';
import { resolveCatalogEmbedForPath } from './catalogEmbed.config';

/**
 * Returns the active catalog embed config, or `null` when the catalog is rendering in its normal
 * (public shop / US admin shop) mode. Derived from the current route so it is visible to every
 * catalog hook regardless of where in the tree that hook runs.
 */
export const useCatalogEmbed = (): CatalogEmbedConfig | null => {
  const { pathname } = useLocation();
  return resolveCatalogEmbedForPath(pathname);
};
